module.exports = __webpack_public_path__ + "static/media/cmsContentImg1.ce2438d3.jpg";